import { atom } from 'jotai';

import { type HelpdeskData } from '@/features/user/types/helpdesk-types';

// eslint-disable-next-line import/prefer-default-export
export const helpdeskDataAtom = atom<HelpdeskData | null>(null);
